import Vue from "vue"
import AppSettings from '@/appSettings';

import './register-router-hooks'
import './register-components'
import app from './components/app.vue'
import uiComponents from "ui-components";


import api from './api/dataSource/api/apiDataSource.plugin'
declare var ApiUrl:string //вебпак заменит на нужное значение при сборке
// Vue.use(api,ApiUrl);
var wshost = AppSettings.socketUrl;
Vue.use(api, wshost, true);


import mainStore from './plugins/mainStore'
Vue.use(mainStore);

import cacheProvider from './plugins/cacheProvider'
Vue.use(cacheProvider);

import vSelect from "vue-select";
Vue.component('v-select', vSelect)

import domPlugin from './plugins/DomPlugin'
Vue.use(domPlugin);

// подключение popup с подтверждением
import dialogPlugin from "./plugins/Confirm/dialog/plugin.dialog"
Vue.use(dialogPlugin);
// подключение модуля copyPaste
import copyPaste from "./plugins/copyPaste/plugin.copyPaste"
Vue.use(copyPaste);
// подключение оповещений
import notificationPlugin from "./plugins/Confirm/notification/plugin.notification"
Vue.use(notificationPlugin);


// Подключение фильтров
import "./filters/moment.ts"
import "./filters/yesNo.ts"
import "./filters/translations.ts"
import "./filters/serverTypes.ts"
import "./filters/goal-survey.filter.ts"
import "./filters/meditation-filter.ts"


// import store from "./pages/map-routes/store/MapRoute"

const moment = require('moment')
moment.locale('ru');
Vue.use(require('vue-moment'),{
    moment
});

// import { Component } from "vue-property-decorator";
// Component.registerHooks([
//     "beforeRouteEnter",
//     "beforeRouteLeave",
//     "beforeRouteUpdate",
// ])



import router from './router'

import MiddlewareProcessor from "./middlewares/middlewareProcessor";
import EventBus from "@models/eventBus";
const middlewareProcessor = new MiddlewareProcessor(router);
//console.log('start vue');


const v = new Vue({
    el: "#app",
    router: router,
    // store: store,
    provide: () => ({
        eventBus: new EventBus()
    }),
    template: `<app/>`,
    components: { 
        app,
        uiComponents  
    }
});




//console.dir(Vue)